import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';
import {isAuth, itemsIsLoading} from './isAuth';
import {currentUser, userData} from './getUserData';
import {alert} from './alert';
import {attributesList, filteredAttrsList} from './getAttributes';
import {
	appsList,
	checkedAppsList,
	checkedAppsListInfo,
	chosenApp,
	chosenAppFromGlobalMarket,
	filteredAppsList,
	getInRetailAppsList,
	getUploadProgress
} from './market';
import {filteredUsersList, users} from './users';
import {filteredStoresList, storesReducer, tinyStoresReducer, tinyStoresWithOperatorReducer} from './stores';
import {
	addCompanyReducer,
	companiesReducer,
	companyLanguageReducer,
	operatorTinyCompaniesReducer,
	tinyCompaniesReducer,
	tinyCompaniesWithOperatorReducer
} from './company';
import {rolesReducer} from './roles';
import {languageReducer, requestIsPending} from './commons';
import {changePackageAppsList, filteredPackages, packagesList, retailAppsList, retailPackageAppsList} from './retail';
import {
	appsStatsReducer,
	companiesStatsReducer,
	companyStatsReducer,
	storeStatsReducer,
	totalStatsReducer
} from './stats';
import {alertMessagesReducer} from './alertsMessages';
import {alertNewNotificationsReducer, alertNotificationsReducer} from './alertsNotifications';
import {promoAppsStat, promoOffersStat, promoRetailCallsStat, promoTraderStat} from './promoAppsStat'
import {citiesList, countriesList} from './geo';
import {basicOfferPrefsList, localizedOfferPrefsList} from './offerPrefs';
import {offersList} from './offersList';
import {offer} from './offer';
import {calls} from './calls';
import {
	operatorStatsByCompaniesReducer,
	operatorStatsBySalesPointsReducer,
	operatorTotalStatsReducer
} from "./operatorStats";
import {promoVideoAmountInCompaniesReducer, promoVideoFoldersReducer} from "./promoVideo";
import {latestClientUpdateReducer, saveClientUpdateReducer} from "./clientUpdate";
import {promoterCategories, promoterSections, promoterVideos} from "./promoter";
import {promoterSalesPointActiveDevices, promoterSalesPointStats, promoterVideoStats} from "./promoterStats";
import {promoterSettings} from "./promoterSettings";
import {loanBanks, loanOrder, loanOrderList, loanOrderStatuses} from "./loan";
import {loanSummaryProps} from "./loanSummaryProperty";
import {loanAvailableProps} from "./loanAvailableProperty";
import {maxNumberOfLoanPayments} from "./loanRetailerProperty";
import {playerFolders, playerMediaList} from "./player";
import {playerActiveSalesPoints, playerMediaStats, playerSalesPointStats} from "./playerStats";
import {geoActivity} from "./geoActivity";

export default (history) => combineReducers({
	router: connectRouter(history),
	isAuth,
	itemsIsLoading,
	requestIsPending,
	currentUser,
	userData,
	alert,
	attributesList,
	filteredAttrsList,
	appsList,
	chosenApp,
	chosenAppFromGlobalMarket,
	filteredAppsList,
	users,
	companiesReducer,
	tinyCompaniesReducer,
	tinyCompaniesWithOperatorReducer,
	addCompanyReducer,
	companyLanguageReducer,
	operatorTinyCompaniesReducer,
	rolesReducer,
	checkedAppsList,
	checkedAppsListInfo,
	getInRetailAppsList,
	retailAppsList,
	filteredPackages,
	packagesList,
	changePackageAppsList,
	retailPackageAppsList,
	storesReducer,
	filteredStoresList,
	tinyStoresReducer,
	tinyStoresWithOperatorReducer,
	filteredUsersList,
	getUploadProgress,
	companiesStatsReducer,
	companyStatsReducer,
	storeStatsReducer,
	totalStatsReducer,
	operatorStatsByCompaniesReducer,
	operatorStatsBySalesPointsReducer,
	operatorTotalStatsReducer,
	languageReducer,
	alertMessagesReducer,
	alertNotificationsReducer,
	alertNewNotificationsReducer,
	countriesList,
	citiesList,
	localizedOfferPrefsList,
	basicOfferPrefsList,
	offersList,
	offer,
	calls,
	promoAppsStat,
	appsStatsReducer,
	promoOffersStat,
	promoRetailCallsStat,
	promoTraderStat,
	promoVideoFoldersReducer,
	promoVideoAmountInCompaniesReducer,
	latestClientUpdateReducer,
	saveClientUpdateReducer,
	promoterCategories,
	promoterSections,
	promoterVideos,
	promoterSettings,
	promoterSalesPointStats,
	promoterSalesPointActiveDevices,
	promoterVideoStats,
	loanOrder,
	loanOrderList,
	loanOrderStatuses,
	loanBanks,
	loanSummaryProps,
	loanAvailableProps,
	maxNumberOfLoanPayments,
	playerFolders,
	playerMediaList,
	playerSalesPointStats,
	playerActiveSalesPoints,
	playerMediaStats,
	geoActivity,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js